import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import env from 'src/helpers/env'
import { useAuthenticatedHeaders } from 'src/hooks/auth/app'
import { useTranslatable } from 'src/hooks/locale/utils'
import SwaggerUI from 'swagger-ui-react'

import 'swagger-ui-react/swagger-ui.css'

export default function SwaggerPage(): JSX.Element {
  const t = useTranslatable()

  return (
    <>
      <Helmet title={t('system:dev')} />
      <PageContent />
    </>
  )
}

function PageContent(): React.ReactElement | null {
  const headers = useAuthenticatedHeaders()

  return (
    <SwaggerUI
      url="/openapi.json"
      requestInterceptor={(req) => {
        return {
          ...req,
          url: req.url.replace(new URL(env.SERVICE_URL).origin, location.origin),
          headers: { ...req.headers, ...headers },
        }
      }}
    />
  )
}
